import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;
// ⏳ Async thunk for Manager forward/reject action
export const projectAction = createAsyncThunk(
    "managerProject/projectAction",
    async ({ projectid, action }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/handle-project-action`,
                { projectid, action },
                {
                    withCredentials: true, // if JWT/Cookies
                }
            );

            return response.data; // { message, project }
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Something went wrong"
            );
        }
    }
);

const managerMainProjectSlice = createSlice({
    name: "managerMainProject",
    initialState: {
        loading: false,
        successMessage: "",
        error: "",
        updatedProject: null,
    },
    reducers: {
        resetProjectActionState: (state) => {
            state.loading = false;
            state.successMessage = "";
            state.error = "";
            state.updatedProject = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(projectAction.pending, (state) => {
                state.loading = true;
                state.error = "";
                state.successMessage = "";
            })
            .addCase(projectAction.fulfilled, (state, action) => {
                state.loading = false;
                state.successMessage = action.payload.message;
                state.updatedProject = action.payload.project;
            })
            .addCase(projectAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetProjectActionState } = managerMainProjectSlice.actions;
export default managerMainProjectSlice.reducer;
